import { createLucideIcon } from "lucide-react";

export const ArrowTurnForward = createLucideIcon(
    "ArrowTurnForward",
    [
        [
            "path",
            {
                d: "M13 6H8.5C6.01472 6 4 8.01472 4 10.5C4 12.9853 6.01472 15 8.5 15H19",
                key: "yz7xtr",
            },
        ],
        [
            "path",
            {
                d: "M17 18L19.2929 15.7071C19.6262 15.3738 19.7929 15.2071 19.7929 15C19.7929 14.7929 19.6262 14.6262 19.2929 14.2929L17 12",
                key: "1iy3ib",
            },
        ],
    ],
);
